import { memo, useCallback } from "react";
import ShareIcon from "@/common/images/icons/share_icon.svg?react";
import FullScreenIcon from "@/common/images/icons/fullScreenIcon.svg?react";
import ExitFullScreenIcon from "@/common/images/icons/exitFullScreen.svg?react";
import ViewIcon from "@/common/images/icons/eye.svg?react";
import SDIcon from "@/common/images/icons/sd.svg?react";
import HDIcon from "@/common/images/icons/hd.svg?react";
import { Actions } from "./types";
import { SoundButton } from "@/components/buttons/SoundButton";
import "./VideoButtons.scss";

interface VideoButtonsProps {
  hasSound: boolean;
  fullScreen: boolean;
  hd: boolean;
  muted: boolean;
  haveFullScreen: boolean;
  onClick: (value: Actions) => void;
}

export const VideoButtons = memo((props: VideoButtonsProps) => {
  const handleClick = useCallback((id: Actions) => () => {
    props.onClick(id);
  }, [props.onClick]);

  return (
    <ul className="sidebar">
      <li className="item">
        <button className="viewButton" onClick={handleClick(Actions.View)}>
          <ViewIcon />
        </button>
      </li>
      {props.hasSound && (
        <li className="item">
          <SoundButton
            enabled={!props.muted}
            onClick={handleClick(props.muted ? Actions.UnMute : Actions.Mute)}
          />
        </li>
      )}
      <li className="item">
        <button className="shareButton" onClick={handleClick(Actions.Share)}>
          <ShareIcon />
        </button>
      </li>
      <li className="item">
        <button className="gifQualityButton" onClick={handleClick(props.hd ? Actions.SD : Actions.HD)}>
          {props.hd ? <HDIcon /> : <SDIcon />}
        </button>
      </li>
      <li className="item">
        <button className="FSButton" onClick={handleClick(Actions.FullScreen)}>
          {props.fullScreen ? <ExitFullScreenIcon /> : <FullScreenIcon />}
        </button>
      </li>
    </ul>
  );
});
